import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceSelectDatatableService } from '../resource-select/resource-select-datatable.service';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { ResourceSelectComponent } from '@klickdata/shared-components/src/selection-handler/resources-assign/resource-select/resource-select.component';

@Component({
    selector: 'app-resource-selection-regardless-id',
    templateUrl: './resource-selection-regardless-id.component.html',
    styleUrls: ['./resource-selection-regardless-id.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ResourceSelectDatatableService],
})
export class ResourceSelectionRegardlessIdComponent extends ResourceSelectComponent {
    constructor(
        public datatableService: ResourceSelectDatatableService,
        protected mobileService: MobileService,
        protected auth: AuthService
    ) {
        super(datatableService, mobileService, auth);
    }

    detectIdKeyValueChange() {
        this.refresh(this.accessForm.value.id);
    }
    public refresh(id?: any): void {
        const filters: Array<{ property: string; items: (string | number)[] }> = [
            { property: 'scope', items: [this.scope_id] },
        ];
        // const filters = [{ property: 'scope', items: [this.scope_id] }];
        if (this.referenceFilter) {
            filters.push({ property: this.referenceFilter, items: [id ?? 'null'] });
        }
        if (!!this.eager?.length) {
            filters.push({ property: 'eager', items: this.eager });
        }
        this.filter?.createOrUpdateWithoutEmitFilter(filters);
    }
}
